//

// ******************************************************************
// * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. *
// ******************************************************************
import { DiscoveryApi } from '../types/discovery';
import { FetchApi } from '../types/fetch';
import crossFetch from 'cross-fetch';
import { pluginId } from '../pluginId';
import * as parser from 'uri-template';
import { EventStatusInner } from '../models/EventStatusInner.model';

/**
 * Wraps the Response type to convey a type on the json call.
 *
 * @public
 */
export type TypedResponse<T> = Omit<Response, 'json'> & {
  json: () => Promise<T>;
};

/**
 * Options you can pass into a request for additional information.
 *
 * @public
 */
export interface RequestOptions {
  token?: string;
}
/**
 * @public
 */
export type GetEventstatusByCorrelationId = {
  path: {
    id: string;
  };
};
/**
 * @public
 */
export type GetEventstatusById = {
  path: {
    id: string;
  };
};

/**
 * @public
 */
export class DefaultApiClient {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: {
    discoveryApi: { getBaseUrl(pluginId: string): Promise<string> };
    fetchApi?: { fetch: typeof fetch };
  }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi || { fetch: crossFetch };
  }

  /**
   * eventstatus by correlation id
   * @param id -
   */
  public async getEventstatusByCorrelationId(
    // @ts-ignore
    request: GetEventstatusByCorrelationId,
    options?: RequestOptions,
  ): Promise<TypedResponse<Array<EventStatusInner>>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/correlations/{id}`;

    const uri = parser.parse(uriTemplate).expand({
      id: request.path.id,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }

  /**
   * eventstatus by id
   * @param id -
   */
  public async getEventstatusById(
    // @ts-ignore
    request: GetEventstatusById,
    options?: RequestOptions,
  ): Promise<TypedResponse<Array<EventStatusInner>>> {
    const baseUrl = await this.discoveryApi.getBaseUrl(pluginId);

    const uriTemplate = `/{id}`;

    const uri = parser.parse(uriTemplate).expand({
      id: request.path.id,
    });

    return await this.fetchApi.fetch(`${baseUrl}${uri}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options?.token && { Authorization: `Bearer ${options?.token}` }),
      },
      method: 'GET',
    });
  }
}
